import React from 'react'
import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2, successAlertRefresh } from './CommonUtils/SweetAlerts';
import { config } from './CommonUtils/CommonURLS';
import { CommonAxiosPost } from './CommonUtils/CommonAxios';
export default function ChangePassword() {


    const changepswFormik = useFormik({
        enableReinitialize: true,
        initialValues: {

            oldpassword: "",
            newpassword: "",
            renewpassword: "",
        },
        validationSchema: Yup.object({
            oldpassword: Yup.string()
                .required('Old password is required')
                .min(8, 'Password must be at least 8 characters'),
            newpassword: Yup.string()
                .required('New password is required')
                .min(8, 'Password must be at least 8 characters')
                .matches(/[0-9]/, 'Password must contain at least one numeric character')
                .matches(/[a-zA-Z]/, 'Password must contain at least one alphabetic character')
                .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
                .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                .matches(/[a-z]/, 'Password must contain at least one lowercase letter'),
            renewpassword: Yup.string()
                .required('Confirm new password is required')
                .oneOf([Yup.ref('newpassword')], 'Retype Password must match with  New Password')
        }),
        onSubmit: (val) => {

            console.log("Change Password Form Values:", val);
            Swal.fire({
                text: "Are you sure you want to Change Password?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Change it!",
                cancelButtonText: "No, cancel!",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = config.url.FAC_URL + "changePassword";
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === "01") {
                            successAlertRefresh(res?.data?.sdesc)
                            // handleLogout();

                        } else {
                            failureAlert(res?.data?.sdesc || "Failed to Change Password");
                        }
                    })
                }
            });
        },
    })


    return (
        <>

            {/* <div className='fac-topbar'>

                <div className='fac-detnew'>
                    <h5 className='mb-0'>Change Password</h5>
                </div>

            </div>
            <FormikProvider value={changepswFormik}>

                <Form onChange={changepswFormik?.handleChange} onSubmit={changepswFormik?.handleSubmit} className="form_adjust faculty-form" >

                    <bie.Row className="px-2 pt-3 mb-3">
                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                            <label className='field-mandatory' >Old Password</label>
                            <Field type="text" name="oldpassword" className="form-control" />
                            <ErrorMessage name="oldpassword" component="div" className="text-danger" />
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                            <label className='field-mandatory'>New Password</label>
                            <Field type='text' name="newpassword" className='form-control' />
                            <ErrorMessage name="newpassword" component="div" className="text-danger" />
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-2'>
                            <label className='field-mandatory'>Re-enter New Password</label>
                            <Field type='text' name="renewpassword" className='form-control' />
                            <ErrorMessage name="renewpassword" component="div" className="text-danger" />
                        </bie.Col>
                    </bie.Row>
                    <bie.Alert variant='success'>
                        <div>
                            <ul>
                                <li>Password must be at least 8 characters.</li>
                                <li>Must have at least one numeric, one alphabet, and one special character.</li>
                                <li>Must have at least one uppercase and one lowercase character.</li>
                            </ul>
                        </div>
                    </bie.Alert>

                    <div className="d-flex justify-content-end mt-3">

                        <button
                            type="submit"
                            className="btn btn-primary btn-sm submit-btn border-0 modal-footbtn"
                        >
                            Reset Password
                        </button>
                        {closeModal && (
                            <button
                                type="button"
                                className="btn btn-danger btn-sm border-0 modal-footbtn ms-2"
                                onClick={closeModal}
                            >
                                Close
                            </button>
                        )}

                    </div>

                </Form>

            </FormikProvider > */}

            <div className="changepsw-wrapper">
                <div className="changepsw-card">

                    {/* LEFT IMAGE */}
                    <div className="changepsw-left">
                        <img src="/pass.avif" alt="profile" />
                    </div>

                    {/* RIGHT FORM */}
                    <div className="changepsw-right">

                        <h3 className="mb-3">Change Password</h3>

                        <FormikProvider value={changepswFormik}>
                            <Form onSubmit={changepswFormik.handleSubmit}>

                                <div className="mb-3">
                                    <label>Old Password</label>
                                    <Field type="password" name="oldpassword" className="form-control" />
                                    <ErrorMessage name="oldpassword" component="div" className="text-danger" />
                                </div>

                                <div className="mb-3">
                                    <label>New Password</label>
                                    <Field type="password" name="newpassword" className="form-control" />
                                    <ErrorMessage name="newpassword" component="div" className="text-danger" />
                                </div>

                                <div className="mb-3">
                                    <label>Confirm Password</label>
                                    <Field type="password" name="renewpassword" className="form-control" />
                                    <ErrorMessage name="renewpassword" component="div" className="text-danger" />
                                </div>

                                <div className="psw-rules">
                                    <ul>
                                        <li>Min 8 characters</li>
                                        <li>1 number, 1 letter, 1 special char</li>
                                        <li>Uppercase & lowercase required</li>
                                    </ul>
                                </div>

                                <button type="submit" className="btn btn-primary w-100">
                                    Reset Password
                                </button>

                            </Form>
                        </FormikProvider>

                    </div>
                </div>
            </div>

        </>
    )
}
